<template>
  <transition name="slide-fade-main"
              mode="out-in"
              appear>
    <router-view />
  </transition>
</template>
<script>
export default {};
</script>
<style lang="scss"></style>
